(function () {
  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault();
    const selected = select.options[select.selectedIndex];
    const imageSource = selected && selected.dataset.variantImg;
    if (!imageSource) return;

    const item = select.closest('.cart-drawer-upsell-list-item');
    const image = item && item.querySelector('.cart-drawer-upsell-list-item-left img');
    if (image) image.src = imageSource;
  };

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.cart-drawer-upsell-nav-btn');
    if (!button) return;

    const upsell = button.closest('#cart-drawer-upsell');
    const list = upsell && upsell.querySelector('.cart-drawer-upsell-list');
    if (!list) return;

    event.preventDefault();
    const direction = button.classList.contains('cart-drawer-upsell-prev') ? -1 : 1;
    list.scrollBy({ left: list.clientWidth * direction, behavior: 'smooth' });
  });
})();
